import { mediaUrl } from "@/lib/api";
import { Panel, TempBadge, Toggle } from "./Fields";
import { MediaInput } from "./MediaInput";

export const HeroTab = ({ settings: s, onChange }) => (
  <div className="space-y-6">
    <Panel title="Vídeo de fundo" desc="Envie um MP4 (ideal: 15–30 s, 1080p, até ~20 MB) ou cole a URL de um vídeo .mp4/.webm. A versão para celular é opcional e deixa o carregamento mais leve.">
      <div className="space-y-8">
        <MediaInput kind="video" label="Vídeo — computador" value={s.hero_video_url} onChange={(v) => onChange("hero_video_url", v)} testid="hero-video-desktop" />
        <MediaInput kind="video" label="Vídeo — celular (opcional, mais leve)" value={s.hero_video_mobile_url} onChange={(v) => onChange("hero_video_mobile_url", v)} testid="hero-video-mobile" />
        <MediaInput label="Imagem alternativa (quando o vídeo não carregar)" value={s.hero_fallback_image} onChange={(v) => onChange("hero_fallback_image", v)} testid="hero-fallback" help="Também é exibida para visitantes que preferem movimento reduzido." />
        <div className="flex flex-wrap items-center gap-4">
          <Toggle label="Mídia ilustrativa (banco de imagens)" checked={s.hero_media_temporary} onChange={(v) => onChange("hero_media_temporary", v)} testid="hero-temporary-toggle" />
          {s.hero_media_temporary && <TempBadge />}
        </div>
      </div>
    </Panel>
    <Panel title="Pré-visualização" desc="Como a primeira tela ficará com o vídeo e a camada escura.">
      <div className="relative aspect-video w-full overflow-hidden bg-[#08080A]" data-testid="hero-live-preview">
        {s.hero_fallback_image && <img src={mediaUrl(s.hero_fallback_image)} alt="" className="absolute inset-0 h-full w-full object-cover" />}
        {s.hero_video_url && <video key={s.hero_video_url} src={mediaUrl(s.hero_video_url)} autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-b from-[#08080A]/70 via-[#08080A]/45 to-[#08080A]" />
        <div className="absolute inset-0 p-6 sm:p-10 flex flex-col justify-end">
          <p className="label-caps">{s.hero_badge}</p>
          <p className="font-display text-3xl sm:text-5xl text-white mt-3">{s.hero_title}</p>
          <p className="text-sm text-[#D4D4D8] mt-3 max-w-md">{s.hero_subtitle}</p>
        </div>
      </div>
    </Panel>
  </div>
);
